import { getRiskAssessmentCompletionPath } from '@gcv/shared';

export interface RiskAssessmentNotificationTarget {
  result_id?: string;
  group_key?: string;
}

export const getAssigneeSummary = (assigneeNames: string | undefined): string => {
  // assignee_names includes the recipient, so remove them to count the others.
  const others =
    (assigneeNames ?? '')
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean).length - 1;

  if (others < 1) {
    return 'you';
  }

  return `you and ${others} ${others === 1 ? 'other' : 'others'}`;
};

export const getRiskAssessmentNotificationPath = (
  data: RiskAssessmentNotificationTarget
): string | undefined => {
  if (!data.result_id) {
    return undefined;
  }

  const path = getRiskAssessmentCompletionPath(data.result_id);

  // group_key is not on the shared payloads yet; update once the shared helper takes one.
  return data.group_key ? `${path}?group=${encodeURIComponent(data.group_key)}` : path;
};
